import { INavModuleConfig } from "@mt-ng2/nav-module";

export const NavConfigOverride: INavModuleConfig = {
    showSubmitHelpButton: false,
};
